import 'semantic-ui-css/semantic.min.css';

import AuthCallback from '@/auth/AuthCallback.vue';
import CustomerOverview from '@/views/customers/CustomerOverview';
import CustomersList from '@/views/customers/CustomersList';
import CustomerGatewayForm from '@/views/customers/views/gateways/CustomerGatewayForm';
import CustomerGatewayOverrideForm from '@/views/customers/views/gateways/CustomerGatewayOverrideForm';
import CustomerGatewaysList from '@/views/customers/views/gateways/CustomerGatewaysList';
import CustomerTemplateConfiguration from '@/views/customers/views/templates/views/CustomerTemplateConfiguration';
import CustomerTemplatesList from '@/views/customers/views/templates/views/CustomerTemplatesList';
import CustomerWorkshopScheduleForm from '@/views/customers/views/workshop-schedule/CustomerWorkshopScheduleForm';
import CustomerWorkshopScheduleList from '@/views/customers/views/workshop-schedule/CustomerWorkshopScheduleList';
import GatewayForm from '@/views/gateways/GatewayForm.vue';
import GatewayOverview from '@/views/gateways/GatewayOverview.vue';
import GatewayProcessMonitoring from '@/views/gateways/GatewayProcessMonitoring';
import GatewaysList from '@/views/gateways/GatewaysList.vue';
import GatewayInstructionsForm from '@/views/gateways/GatewayInstructionsForm.vue';
import GatewayBindingsForm from '@/views/gateways/GatewayBindingsForm.vue';
import GatewayCustomers from '@/views/gateways/GatewayCustomers.vue';
import GatewayActions from '@/views/gateways/GatewayActions.vue';
import Login from '@/views/LoginView.vue';
import ScreensLogsList from '@/views/ScreensLogsList.vue';
import UsersList from '@/views/users/UsersList.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/auth-callback',
        name: 'AuthCallback',
        component: AuthCallback,
    },
    {
        path: '/customers',
        name: 'CustomersList',
        component: CustomersList,
    },
    {
        path: '/customers/:customer_id([0-9]+)/workshop-schedule/list',
        name: 'CustomerWorkshopScheduleList',
        component: CustomerWorkshopScheduleList,
    },
    {
        path: '/customers/:customer_id([0-9]+)/workshop-schedule/:workshop_schedule_id([0-9]+)?',
        name: 'CustomerWorkshopScheduleForm',
        component: CustomerWorkshopScheduleForm,
    },
    {
        path: '/customers/:customer_id([0-9]+)/overview',
        name: 'CustomerOverview',
        component: CustomerOverview,
    },
    {
        path: '/customers/:customer_id([0-9]+)/gateway-files/:gateway_file_id([0-9]+)?',
        name: 'CustomerGatewayForm',
        component: CustomerGatewayForm,
    }, {
        path: '/customers/:customer_id([0-9]+)/gateway/:gateway_id([0-9]+)?/override',
        name: 'CustomerGatewayOverrideForm',
        component: CustomerGatewayOverrideForm,
    }, {
        path: '/customers/:customer_id/gateways/list',
        name: 'CustomerGatewaysList',
        component: CustomerGatewaysList,
    },
    {
        path: '/customers/:customer_id/templates/:template_id/configurations/:configuration_id',
        name: 'CustomerTemplateConfigurationEdit',
        component: CustomerTemplateConfiguration,
    },
    {
        path: '/customers/:customer_id/templates/:template_id/configurations',
        name: 'CustomerTemplateConfigurationNew',
        component: CustomerTemplateConfiguration,
    },
    {
        path: '/customers/:customer_id/templates',
        name: 'CustomerTemplatesList',
        component: CustomerTemplatesList,
    },
    {
        path: '/gateway/new',
        name: 'GatewayForm',
        component: GatewayForm,
    }, 
    {
        path: '/gateways/list',
        name: 'GatewaysList',
        component: GatewaysList,
    }, 
    {
        path: '/gateways/:gateway_id([0-9]+)',
        name: 'GatewayOverview',
        component: GatewayOverview,
        redirect: { name: 'GatewaySettings' },
        children: [{ 
            path: 'settings', 
            name: 'GatewaySettings', 
            component: GatewayForm
        }, { 
            path: 'instructions', 
            name: 'GatewayInstructions', 
            component: GatewayInstructionsForm 
        }, { 
            path: 'bindings', 
            name: 'GatewayBindings', 
            component: GatewayBindingsForm 
        }, { 
            path: 'customers', 
            name: 'GatewayCustomers', 
            component: GatewayCustomers 
        }, { 
            path: 'actions', 
            name: 'GatewayActions', 
            component: GatewayActions
        }],
    }, 
    {
        path: '/screens/logs/list',
        name: 'ScreensLogsList',
        component: ScreensLogsList,
    }, 
    {
        path: '/customers/:customer_id/gateways-files/:gateway_file_id/monitoring',
        name: 'GatewayProcessMonitoring',
        component: GatewayProcessMonitoring,
    }, 
    {
        path: '/users',
        name: 'UsersList',
        component: UsersList,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export function useRouter() {
    return router;
}

export function useRoute() {
    return router.currentRoute;
}

export default router;
